import React from 'react';
import { Growl } from 'primereact/growl';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Button } from 'primereact/button';
import { Lightbox } from 'primereact/lightbox';
import servicioArchivo from '../servicios/ServicioArchivos';
import servicioAfil from '../servicios/ServicioAfil';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

export class DetalleAfil extends React.Component {
    constructor(props) {
        super(props)
        const { handle } = this.props.match.params;
        const { id } = this.props.location.state;

        this.state = {
            nombreTrabajador: {},
            tcTrabajador: {},
            paginacion: { registrosPorPagina: 20 },
            inicio: 0,
            iFrameSrc: null,
        }
        let { tcTrabajador, nombreTrabajador } = this.state;

        tcTrabajador.rfc = id.rfc;
        nombreTrabajador.nombre = id.nombre;

    }
    componentDidMount() {
        this.obtenerPagina();

    }

    cambiaPagina(event) {
        let { paginacion } = this.state;

        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerPagina();
    }

    obtenerPagina() {
        let { paginacion, tcTrabajador } = this.state;
        let nombrePropiedad = "alias_tcTrabajador.rfc";
        paginacion.restricciones = {};
        paginacion.restricciones[nombrePropiedad] = tcTrabajador.rfc;

        servicioAfil.paginacion(paginacion).then((response) => {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

            if (response.data.error === false)
                this.setState({ paginacion: response.data.objeto });

        }).catch((error) => {
            if (error)
                return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });
    }
    columnaVerArchivo = (rowData, column) => {
        return <div>
            <div>
                <Button icon="pi-md-remove-red-eye" type="button" tooltip="Ver archivo" onClick={(e) => this.visorPdf(column.rowData, 'pdf')}></Button>
            </div>
        </div>;

    }
    visorPdf = (objeto, tipo) => {
        servicioArchivo.descargaArchivoComoBlob('/afil/descarga_por_trabajador.json?id=' + objeto.id + '&tipo=' + tipo)
            .then((response) => {
                this.setState({ iFrameSrc: URL.createObjectURL(response) });
                document.getElementById("btnVisorPdfTarget").click();
            }).catch((error) => {
                this.growl.show({ severity: 'error', summary: '', detail: error });
            });

    }
    render() {
        let { paginacion, inicio, iFrameSrc, nombreTrabajador } = this.state;
        const visorPdfTarget = (
            <button id="btnVisorPdfTarget" className="p-link" style={{ visibility: "hidden" }}></button>
        );
        return (
            <div className="card card-w-title">

                <Growl ref={(el) => this.growl = el} />
                <h1>Afiles del trabajador: {nombreTrabajador.nombre} </h1>
                <Lightbox target={visorPdfTarget}>
                    <div id="contenedorIframe"  >
                        <iframe id="elIframe" src={iFrameSrc} frameBorder="0" className="iframeEstilo" ></iframe>
                    </div>
                </Lightbox>
                <div className="content-section implementation">
                <div className="p-grid">
                <div className="p-col-10"></div>
                    <div className="p-col-2">
                        <Button className="p-button-Primary p-button-raised" label={<Link className="colorRegresar" to={{
                            pathname: "/consultareciboquadrum/bienvenido/expediente",
                            state: {}
                        }}>Regresar</Link>}>

                        </Button>
                    </div>
                    </div>
                    <DataTable value={paginacion.datos} editable={true} selectionMode="single" scrollable={true} resizableColumns={true} responsive={true}>
                        <Column field="nombreArchivo" header="Nombre del archivo" />
                        <Column header="Ver Archivo" body={this.columnaVerArchivo} autoLayout={true} />
                    </DataTable>
                    <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                </div>
            </div>
        );
    }

}